import { useState } from 'preact/hooks';
import { Smartphone, X } from 'lucide-preact';
import { appStoreUrl, detectOS } from '../lib/os';
import { getItem, setItem } from '../lib/storage';
import { locale, t } from '../i18n';

/**
 * Tiny floating "Get the app" chip pinned to the bottom-right of the map.
 * Detects the watcher's OS and links directly to the matching store —
 * desktops fall back to the App Store landing. Dismissible: once closed,
 * we persist a flag in localStorage so it doesn't re-appear.
 */
export function DownloadAppChip() {
  const [dismissed, setDismissed] = useState(() => getItem('appChipDismissed') === '1');
  if (dismissed) return null;

  const os = detectOS();
  const url = appStoreUrl(os, locale.value);

  return (
    <div class="pointer-events-auto fixed bottom-3 right-3 z-20 flex items-stretch">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-1.5 rounded-l-full bg-primary px-3 py-2 text-xs font-medium text-white shadow-md hover:bg-primary-light transition-colors"
      >
        <Smartphone size={14} aria-hidden="true" />
        <span>{t('download.chip')}</span>
      </a>
      <button
        type="button"
        onClick={() => {
          setItem('appChipDismissed', '1');
          setDismissed(true);
        }}
        class="inline-flex items-center justify-center rounded-r-full bg-primary px-2 text-white shadow-md hover:bg-primary-light border-l border-white/20 transition-colors"
        aria-label={t('download.chipDismiss')}
      >
        <X size={14} aria-hidden="true" />
      </button>
    </div>
  );
}
